<template>
  <div class="content-8__controlbar__item fn-content-8__controlbar__item">
    <div class="c8-explanation fn-c8-explanation" fn-hover-open>
      <div class="c8-explanation__icon"></div>
      <span class="c8-explanation__title">说明：</span>
      <component :is="currentTrendExplanation" v-if="!html" />
      <div
        v-else
        flyc-div
        class="c8-explanation__content"
        v-html="usingHTML"
      ></div>
    </div>
  </div>
</template>
<script>
// 路珠類 說明
import type1 from '@/components/web/pages/trend/TrendExplanation/LuJhu/ExplanationType1'
import type2 from '@/components/web/pages/trend/TrendExplanation/LuJhu/ExplanationType2'

// 走勢類 說明
import PK10WebLiangMianHengBanZouShih from '@/components/web/pages/trend/TrendExplanation/pk10/PK10WebLiangMianHengBanZouShih'

export default {
  name: 'TrendExplanation',
  props: {
    lotteryCode: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    },
    html: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      usingLotteryCode: '',
      usingName: '',
      usingHTML: '',
      currentTrendExplanation: null
    }
  },
  async created() {
    const { lotteryCode, name, html } = this
    const usingLotteryCode = lotteryCode !== undefined ? lotteryCode : this.getLotteryCode()
    const usingName = name !== undefined ? name : this.$parent.$options.name
    const usingHTML = html !== undefined ? html : await this.getHTMLMapping(usingLotteryCode, usingName)
    this.currentTrendExplanation = usingHTML
    Object.assign(this, { usingLotteryCode, usingName, usingHTML })
  },
  methods: {
    getLotteryCode() {
      if (this.$route.params.lottery_code) {
        return this.$route.params.lottery_code
      }
      console.warn('TrendExplanation getLotteryCode: 取得lotteryCode 失敗!')
      return ''
    },
    async getHTMLMapping(lotteryCode, trendName) {
      const lotteryType = await this.$getLotteryType(lotteryCode)
      switch (lotteryType) {
        case 'pk10':
          return this.getPK10TrendExplanation(trendName)
        case 'k3':
          return this.getK3TrendExplanation(trendName)
        case '11x5':
          return this.get11x5TrendExplanation(trendName)
        case 'ssc':
          return this.getSscTrendExplanation(trendName)
        case 'kl10':
          return this.getKl10TrendExplanation(trendName)
        case 'xy28':
          return this.getXy28TrendExplanation(trendName)
        case 'kl8':
          return this.getKl8TrendExplanation(trendName)
        default:
          console.warn('TrendExplanation getHTMLMapping: 彩種類型對應失敗!', lotteryCode, lotteryType)
          return null
      }
    },
    getPK10TrendExplanation(trendName) {
      switch (trendName) {
        case 'LongHuLuJhu': // 龍虎路珠
        case 'DanShuangDaXiaoLuJhu': // 单双大小路珠
        case 'GuanYaHeLuJhu': // 冠亞和路珠
        case 'HaoMaChianHouLuJhu': // 號碼前後路珠
        case 'PK10': // 路珠分析
          return type1
        case 'WebLiangMianHengBanZouShihContent':
          return PK10WebLiangMianHengBanZouShih
        default:
          console.warn('TrendExplanation getPK10TrendExplanation: 玩法類型對應失敗!', trendName)
          return null
      }
    },
    getK3TrendExplanation(trendName) {
      switch (trendName) {
        case 'ZongHeLuJhu': // 總和路珠
          return type1
        case 'HaoMaLuJhu': // 號碼路珠
          return type2
        default:
          console.warn('TrendExplanation getK3TrendExplanation: 玩法類型對應失敗!', trendName)
          return null
      }
    },
    get11x5TrendExplanation(trendName) {
      switch (trendName) {
        case 'DanShuangDaXiaoLuJhu': // 單雙大小路珠
        case 'ZongHeLuJhu': // 總和路珠
          return type1
        default:
          console.warn('TrendExplanation get11x5TrendExplanation: 玩法類型對應失敗!', trendName)
      }
    },
    getSscTrendExplanation(trendName) {
      switch (trendName) {
        case 'HaoMaLuJhu': // 號碼路珠
          return type2
        case 'DanShuangDaXiaoLuJhu': // 单双大小路珠
        case 'ZongHeLuJhu': // 總和路珠
        case 'SSC': // 路珠分析
          return type1
        default:
          console.warn('TrendExplanation getSscTrendExplanation: 玩法類型對應失敗!', trendName)
          return null
      }
    },
    getKl10TrendExplanation(trendName) {
      switch (trendName) {
        case 'HaoMaLuJhu': // 號碼路珠
          return type2
        case 'LongHuLuJhu': // 龍虎路珠
        case 'WeiShuDaXiaoLuJhu': // 尾數大小路珠
        case 'HeShuDanShuangLuJhu': // 合數单双路珠
        case 'DongNanSiBeiLuJhu': // 東南西北路珠
        case 'JhongFaBaiLuJhu': // 中發白路珠
        case 'DanShuangDaXiaoLuJhu': // 单双大小路珠
        case 'ZongHeLuJhu': // 總和路珠
        case 'KL10': // 路珠分析
          return type1
        default:
          console.warn('TrendExplanation getKl10TrendExplanation: 玩法類型對應失敗!', trendName)
          return null
      }
    },
    getXy28TrendExplanation(trendName) {
      switch (trendName) {
        case 'PoSeLuJhu': // 總和路珠
        case 'ZongHeLuJhu': // 總和路珠
          return type1
        default:
          console.warn('TrendExplanation getKl10TrendExplanation: 玩法類型對應失敗!', trendName)
          return null
      }
    },
    getKl8TrendExplanation(trendName) {
      switch (trendName) {
        case 'KL8': // 路珠分析
          return type1
        default:
          console.warn('TrendExplanation getKl10TrendExplanation: 玩法類型對應失敗!', trendName)
          return null
      }
    }
  }
}
</script>
<style scoped>
[fn-hover-open]:hover {
  height: auto;
  z-index: 999;
}
.fn-content-8__controlbar__item {
  position: relative;
  min-height: 49PX;
}
.fn-c8-explanation {
  position: absolute;
  z-index: 1;
  width: calc(100% - 32PX);
}
</style>
